import { AxiosRequestConfig } from 'axios';
import { BASE_API, BaseForExerciseCRUD } from '../utils';

export interface CreateExercise extends BaseForExerciseCRUD
{
  parentFolderId: string;
  // Exams supply client-generated id on create so that
  // server can save draft locked exam problems,
  // but Assignments do not supply this
  id?: number;
}

interface CreateConfig extends AxiosRequestConfig {
  body: CreateExercise;
  data: CreateExercise;
  method: 'POST';
  url: '/exercises';
}

/**
 * POST /exercises
 */
export const create = (data: CreateExercise): CreateConfig => {
  return {
    baseURL: BASE_API,
    method: 'POST',
    url: '/exercises',
    body: data,
    data,
  };
};
